<template>
  <div id="footer">
    <div class="container">
      <div class="clearfix">
        <div class="pull-left">
          <div>
            <span class="black-title"><span class="f-dot">-</span>技术服务</span>
          </div>
          <div>
            <span class="skill-text" @click="$router.push('/service/development').catch(() => { })">系统软件开发</span>
          </div>
          <div>
            <span class="skill-text" @click="$router.push('/service/eda').catch(() => { })">EDA软件开发</span>
          </div>
          <div>
            <span class="skill-text" @click="$router.push('/service/manufacture').catch(() => { })">制造业软件开发</span>
          </div>
          <div>
            <span class="skill-text" @click="$router.push('/service/offshore').catch(() => { })">海外开发</span>
          </div>
        </div>
        <div class="pull-right">
          <div>
            <span class="black-title">奥软信息技术(上海)有限公司</span>
          </div>
          <div class="information" style="padding-top: 6px">
            <span>上海市徐汇区南宁路1000号万科中心一期c座706</span>
          </div>
          <div class="information">
            <span>Tel.+86(21)54567355</span>
          </div>
          <br />
          <br />
          <div>
            <span class="black-title">オリゾンシステムズ株式会社</span>
          </div>
          <div class="information" style="padding-top: 6px">
            <span>〒160-0022</span>
          </div>
          <div class="information">
            <span>東京都新宿区新宿6-27-56 新宿スクエア7F</span>
          </div>
          <div class="information">
            <span>Tel.(+81)03-6205-6081</span>
          </div>
          <div class="information">
            <span>Fax.03-3205-6040</span>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="intro">
          <a href="https://beian.miit.gov.cn" target="_blank">备案/许可证编号为：沪ICP备2020029995号</a>&nbsp;
          <img src="@/assets/img/national.png" style="width: 20px;">
          <a rel="noreferrer" target="_blank" id="gongan">沪公网安备31010402334972号</a>
        </div>
        <!-- <a href="" target="_blank"></a> -->
        <!--<p>备案/许可证编号为：沪ICP备2020029995号</p>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: rgb(0, 111, 187);
  background: rgb(235, 235, 235);
  overflow: hidden;
  font-size: 15px;
  /* font-family: arial, helvetica, sans-serif; */
  padding: 3rem 0;
}

.f-dot {
  font-size: 24px;
  font-weight: bold;
  padding-right: 6px;
}

.footer-left {
  padding: 0rem 37rem;
}

.skill-text {
  line-height: 30px;
  cursor: pointer;
}

.black-title {
  color: black;
  font-size: 15px;
  font-weight: bold;
}

.footer-right {
  padding-right: 42rem;
}

.information {
  line-height: 30px;
  color: rgb(51, 51, 51);
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

.footer-bottom {
  color: rgb(51, 51, 51);
  text-decoration: none;
}
.intro{
  display:flex;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue